/**
 * @generated SignedSource<<6fe69bc3bd1552a5e4f3c0b7002a85d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePlaceholderInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deletePlaceholderMutation$variables = {
  input: DeletePlaceholderInput;
};
export type deletePlaceholderMutation$data = {
  readonly deletePlaceholder: {
    readonly deletedPlaceholderId: string | null;
  } | null;
};
export type deletePlaceholderMutation = {
  variables: deletePlaceholderMutation$variables;
  response: deletePlaceholderMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePlaceholderPayload",
    "kind": "LinkedField",
    "name": "deletePlaceholder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedPlaceholderId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deletePlaceholderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deletePlaceholderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "27b07a5b946fd1e5674825e542352c73",
    "id": null,
    "metadata": {},
    "name": "deletePlaceholderMutation",
    "operationKind": "mutation",
    "text": "mutation deletePlaceholderMutation(\n  $input: DeletePlaceholderInput!\n) {\n  deletePlaceholder(input: $input) {\n    deletedPlaceholderId\n  }\n}\n"
  }
};
})();

(node as any).hash = "049af6a9bf490dca961826c02c702850";

export default node;
